import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { TRANSFER_OWNER } from '../actions/actionTypes';
import {
  transferOwnerDone,
  transferOwnerError,
  transferOwnerLoading,
  transferOwnerSuccess
} from '../actions/accountOwner';
import { adminApi } from '../api/AdminApi';

export function* watchTransferAccountOwnerSaga () {
  yield takeLatest(TRANSFER_OWNER, transferAccountOwnerSaga);
}

export function* transferAccountOwnerSaga ({ tenantId, email }) {
  try {
    yield put(transferOwnerLoading());
    const tenant = yield call(adminApi.reassignTenantOwner, tenantId, email);
    yield put(transferOwnerSuccess(tenant));
  } catch (error) {
    yield put(transferOwnerError(error));
  } finally {
    yield put(transferOwnerDone());
  }
}

export default [
  fork(watchTransferAccountOwnerSaga)
];
